(function ($) {
  $(function () {
    var $window = $(window);

    $.fn.isInViewport = function () {
      var elementTop = $(this).offset().top + 150,
        elementBottom = elementTop + $(this).outerHeight(),
        viewportTop = $window.scrollTop(),
        viewportBottom = viewportTop + $window.height();

      return elementBottom > viewportTop && elementTop < viewportBottom;
    };

    if ($(".featured-speakers-module").length > 0) {
      let $module = $(this),
        $slider = $module.find(".featured-speakers-slider");
      $visibleSlides = $slider.data("visible-slides");

      var isChanging = false,
        isFiltered = false;

      if ($slider.hasClass("sticky")) {
        $slider.on("init breakpoint", function (event, slick) {
          if (!isChanging) {
            isChanging = true;
            if ($window.width() >= 960) {
              if (!isFiltered) {
                slick.slickFilter(":not(.hide-on-desktop)");
                isFiltered = true;
              }
            } else {
              if (isFiltered) {
                slick.slickUnfilter();
                isFiltered = false;
              }
            }
            isChanging = false;
          }
        });
      }

      if ($slider.hasClass("stacked")) {
        var slider_settings = {
          slidesToShow: $visibleSlides,
          slidesToScroll: 1,
          rows: 2,
          slidesPerRow: 5,
          dots: false,
          arrows: true,
          prevArrow: $module.find(".slick-arrows .slick-prev"),
          nextArrow: $module.find(".slick-arrows .slick-next"),
          infinite: false,
          speed: 700,
          cssEase: "ease-in-out",
          responsive: [
            {
              breakpoint: 960,
              settings: {
                slidesToShow: 3,
                rows: 1,
                slidesPerRow: 1,
                speed: 500,
              },
            },
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 2,
                rows: 1,
                slidesPerRow: 1,
                speed: 500,
              },
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                rows: 1,
                slidesPerRow: 1,
                speed: 500,
              },
            },
          ],
        };
      } else {
        var slider_settings = {
          slidesToShow: $visibleSlides,
          slidesToScroll: 1,
          rows: 0,
          dots: false,
          arrows: true,
          prevArrow: $module.find(".slick-arrows .slick-prev"),
          nextArrow: $module.find(".slick-arrows .slick-next"),
          infinite: false,
          speed: 300,
          cssEase: "linear",
          responsive: [
            {
              breakpoint: 960,
              settings: {
                slidesToShow: 3,
              },
            },
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 2,
              },
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
              },
            },
          ],
        };
      }

      $slider.slick(slider_settings);

      $(".slick-slider .slick-dots button").attr("tabindex", 0);
    }

    $(window).on("load", function () {
      $(".modal .modal-close").on("click", function () {
        $iframe = $(this).parent().find("iframe");
        $videoSrc = $iframe.attr("src");
        $iframe.attr("src", "");
        $iframe.attr("src", $videoSrc);
      });

      $(".bio-read-more").on("click", function () {
        $(this).parent(".bio-cut").hide().siblings(".bio-full").show();
      });
    });

    $(".accordion-trigger").on("click", function () {
      var $this = $(this);
      $this.toggleClass("active");

      if ($this.hasClass("active")) {
        $this.siblings(".accordion-content").slideDown();
      } else {
        $this.siblings(".accordion-content").slideUp();
      }
    });

    $(".tab-trigger").on("click", function () {
      var $this = $(this);

      $this.siblings().removeClass("active");
      $this.addClass("active");

      $this
        .parent(".tab-trigger-group")
        .siblings(".tab-panel-group")
        .find(".tab-panel")
        .hide();
      $this
        .parent(".tab-trigger-group")
        .siblings(".tab-panel-group")
        .find("#" + $this.data("tab-panel"))
        .show();

      if ($this.hasClass("active")) {
      }
    });

    $(".hamburger").on("click", function () {
      var $this = $(this);
      $this.toggleClass("active");

      if ($this.hasClass("active")) {
        $("body").css({ overflow: "hidden" });
        $(".breakthrough-2024-navbar .logo").css({ "z-index": 999 });
        $(".mobile-navigation-menu").css({ "--tw-translate-x": 0 });
        $(".mobile-navigation-overlay").css({
          opacity: 1,
          visibility: "visible",
        });
      }
    });

    $(".mobile-navigation-overlay, .mobile-navigation-menu a").on(
      "click",
      function () {
        $(".hamburger").removeClass("active");

        $("body").css({ overflow: "" });
        setTimeout(function () {
          $(".breakthrough-2024-navbar .logo").css({ "z-index": 0 });
        }, 300);
        $(".mobile-navigation-menu").css({ "--tw-translate-x": "-100%" });
        $(".mobile-navigation-overlay").css({
          opacity: 0,
          visibility: "hidden",
        });
      }
    );

    $window.on("resize", function () {
      if ($window.width() >= 768) {
        $(".hamburger").removeClass("active");

        $("body").css({ overflow: "" });
        setTimeout(function () {
          $(".breakthrough-2024-navbar .logo").css({ "z-index": 0 });
        }, 300);
        $(".mobile-navigation-menu").css({ "--tw-translate-x": "-100%" });
        $(".mobile-navigation-overlay").css({
          opacity: 0,
          visibility: "hidden",
        });
      }
    });
  });
})(jQuery);
